/**
 * Features Section - Landing Page
 */

import React from 'react';
import { Shield, Zap, Globe, Lock } from 'lucide-react';
import { Card } from '../../../../design-system';

const Features = ({ language }) => {
  const isArabic = language === 'ar';

  const features = isArabic
    ? [
        { 
          icon: Shield, 
          title: 'آمن جداً', 
          description: 'تشفير من الدرجة الأولى وتوافقي مع معايير الأمان الدولية' 
        },
        { 
          icon: Zap, 
          title: 'سريع جداً', 
          description: 'توصيل فوري للرموز في أقل من ثانية' 
        },
        { 
          icon: Globe, 
          title: 'عالمي', 
          description: 'يدعم جميع الدول العربية والدول العالمية' 
        },
        { 
          icon: Lock, 
          title: 'موثوق', 
          description: 'معدل نجاح عالي جداً في التوصيل' 
        },
      ]
    : [
        { 
          icon: Shield, 
          title: 'Secure', 
          description: 'Enterprise-grade encryption and compliance' 
        },
        { 
          icon: Zap, 
          title: 'Fast', 
          description: 'Instant delivery in less than a second' 
        },
        { 
          icon: Globe, 
          title: 'Global', 
          description: 'Support for Arab and International markets' 
        },
        { 
          icon: Lock, 
          title: 'Reliable', 
          description: 'High delivery success rates guaranteed' 
        },
      ];

  return (
    <section id="features" className="w-full py-16 sm:py-24 md:py-32 lg:py-48 px-3 sm:px-4 bg-[#0B0E14] relative">
      {/* Background accent */}
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-[#128C7E]/5 to-transparent pointer-events-none" />
      
      <div className="relative max-w-6xl mx-auto">
        <div className="text-center mb-12 sm:mb-16 lg:mb-20">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white text-center mb-4 sm:mb-6">
            {isArabic ? 'المميزات' : 'Features'}
          </h2>
          <p className="text-sm sm:text-base md:text-lg text-[#A0AEC0] max-w-2xl mx-auto leading-relaxed">
            {isArabic ? 'كل ما تحتاجه لخدمة OTP موثوقة وآمنة' : 'Everything you need for reliable OTP service'}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 lg:gap-8">
          {features.map((feature, index) => {
            const Icon = feature.icon;
            return (
              <Card key={index} glass hoverable className="relative p-6 sm:p-8 border-l-4 border-l-[#128C7E]/30 hover:border-l-[#128C7E] hover:bg-[#1A1D23]/50 transition-all group">
                <div className="mb-4 sm:mb-6 inline-flex items-center justify-center w-12 h-12 sm:w-14 sm:h-14 bg-[#128C7E]/10 rounded-xl group-hover:bg-[#128C7E]/20 transition-all">
                  <Icon className="w-6 h-6 sm:w-7 sm:h-7 text-[#128C7E]" />
                </div>
                <h3 className="text-lg sm:text-xl font-semibold text-white mb-2 sm:mb-3">
                  {feature.title}
                </h3>
                <p className="text-[#A0AEC0] text-xs sm:text-sm leading-relaxed">
                  {feature.description}
                </p>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Features;
